<template>
  <div class="filter-checkbox">
    <div class="d-flex mt-2">
      <PrimaryButton @click="handleSelectAll" text shrink>
        Select All
      </PrimaryButton>
      <ErrorButton @click="handleClear" text shrink v-if="!isEmpty(values)">
        Clear
      </ErrorButton>
    </div>
    <v-text-field v-model="searchText" placeholder="Search" clearable />
    <v-checkbox
      v-for="(option, index) in filteredOptions"
      :key="`option-${index}`"
      color="black"
      :label="option.text"
      :value="option.value"
      v-model="values"
      :input-value="values"
      @change="saveChanges"
      multiple
      dense
    />
  </div>
</template>

<script>
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import ErrorButton from "@/components/common/Button/ErrorButton";
import { map, isEmpty, uniq, size } from "lodash";
import { searchInFilterOptions } from "@/utils/filters";

export default {
  props: {
    /**
     * Array of objects containing the label and values
     * [{
     *  value,
     *  label
     * }]
     */
    options: {
      type: Array,
      required: true
    },
    /**
     * Default selected value
     */
    selectedValues: {
      type: [Array, String, Number],
      required: false,
      default() {
        return [];
      }
    }
  },
  components: { PrimaryButton, ErrorButton },
  data() {
    return {
      values: this.selectedValues,
      searchText: ""
    };
  },
  computed: {
    filteredOptions() {
      return searchInFilterOptions(this.searchText, this.options);
    }
  },
  methods: {
    saveChanges(newValues) {
      if (newValues) {
        this.values =
          size(newValues) === size(this.values) - 1 && !this.searchText
            ? newValues
            : uniq([...this.values, ...newValues]);
      }
      this.$emit("change", this.values);
    },
    handleSelectAll() {
      this.values = [];
      map(this.options, option => this.values.push(option.value));
      this.saveChanges();
    },
    handleClear() {
      this.values = [];
      this.saveChanges();
    },
    isEmpty
  }
};
</script>

<style lang="scss">
.filter-checkbox {
  .v-input.v-text-field {
    margin-top: 0;
  }
  .base-button.shrink.v-btn:not(.v-btn--round).v-size--default {
    padding: 0.2rem !important;
  }
}
</style>
